{
  "languages": {
    "select": "Sprache wählen",
    "english": "En",
    "french": "FR",
    "german": "DE",
    "spanish": "ES",
    "portuguese": "PT"
  },
  "nav": {
    "dashboard": "Dashboard",
    "clients": "Kunden",
    "myBookings": "Meine Buchungen",
    "loginTrainer": "Anmeldung für Trainer",
    "login": "Anmelden",
    "logout": "Abmelden",
    "accountSettings": "Kontoeinstellungen",
    "changePassword": "Passwort ändern",
    "home": "Startseite",
    "pricing": "Preise",
    "contact": "Kontakt",
    "affiliate": "Partnerprogramm",
    "yogaStudioSoftware": "Yoga Studio Software",
    "pilatesStudioSoftware": "Pilates Studio Software",
    "cantienicaStudioSoftware": "CANTIENICA Studio Software",
    "resources": "Ressourcen",
    "guides": "Anleitungen",
    "blog": "Blog"
  },
  "accountSettings": {
    "title": "Kontoeinstellungen",
    "editTitle": "Profil bearbeiten",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "email": "E-Mail",
    "phone": "Telefon",
    "updateSuccess": "Profil aktualisiert",
    "updateSuccessMessage": "Dein Profil wurde erfolgreich aktualisiert",
    "firstNameRequired": "Vorname ist erforderlich",
    "lastNameRequired": "Nachname ist erforderlich",
    "dangerZone": "Gefahrenzone",
    "deleteAccount": "Mein Konto löschen",
    "deleteWarning": "Dies wird dein Konto und alle zugehörigen Daten dauerhaft löschen. Diese Aktion kann nicht rückgängig gemacht werden.",
    "confirmDelete": "Bist du sicher, dass du dein Konto löschen möchtest?",
    "deleteSuccess": "Konto gelöscht",
    "deleteSuccessMessage": "Dein Konto wurde erfolgreich gelöscht.",
    "deleteDialog": {
      "title": "Mein Konto löschen",
      "description": "Bist du sicher, dass du dein Konto und alle zugehörigen Daten löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
    }
  },
  "password": {
    "changeTitle": "Passwort ändern",
    "current": "Aktuelles Passwort",
    "new": "Neues Passwort",
    "confirm": "Neues Passwort bestätigen",
    "error": "Fehler",
    "mismatch": "Die neuen Passwörter stimmen nicht überein",
    "updateSuccess": "Passwort aktualisiert",
    "updateSuccessMessage": "Ihr Passwort wurde erfolgreich aktualisiert",
    "currentPasswordRequired": "Aktuelles Passwort ist erforderlich",
    "newPasswordRequired": "Neues Passwort ist erforderlich",
    "confirmPasswordRequired": "Passwortbestätigung ist erforderlich",
    "passwordsDoNotMatch": "Die Passwörter stimmen nicht überein"
  },
  "classes": {
    "title": "Verfügbare Kurse",
    "bookIntro": "Buchen Sie Ihre nächste Sitzung mit unseren erfahrenen Trainern",
    "bookNow": "Jetzt buchen",
    "online": "Online",
    "spots": "Verfügbare Plätze",
    "noClassesAvailableClearFilter": "Keine Kurse verfügbar. Bitte versuchen Sie ein anderes Datum oder löschen Sie den Filter, um alle verfügbaren Kurse zu sehen.",
    "noClassesAvailable": "Keine Kurse verfügbar.",
    "confirmBookingTitle": "Kurs Gebucht!",
    "confirmBookingDescription": "Sie haben erfolgreich den Kurs {title} mit {trainer} am {date} um {time} gebucht."
  },
  "classForm": {
    "title": "Titel",
    "datetime": "Datum/Uhrzeit",
    "duration": "Dauer",
    "capacity": "Kapazität",
    "price": "Preis",
    "currency": "Währung",
    "status": "Status",
    "statusOptions": {
      "available": "Verfügbar",
      "canceled": "Abgesagt",
      "hidden": "Versteckt"
    },
    "location": "Standort",
    "locationOptions": {
      "studio": "Studio",
      "online": "Online"
    },
    "trainer": "Trainer",
    "isRecurring": "Wiederkehrende Klasse",
    "submit": "Absenden",
    "repeatEvery": "Wiederholt sich alle",
    "repeatPeriod": "Periode",
    "repeatPeriodOptions": {
      "week": "Woche",
      "month": "Monat",
      "year": "Jahr"
    },
    "maxEvents": "Maximale Anzahl an Ereignissen",
    "validation": {
      "titleRequired": "Der Titel muss mindestens 2 Zeichen lang sein.",
      "minCapacity": "Die Kapazität muss mindestens 1 betragen.",
      "maxEvents": "Die maximale Anzahl an Ereignissen muss zwischen 1 und 24 liegen."
    },
    "cancelClass": "Kurs stornieren",
    "deleteClass": "Kurs löschen",
    "cancelDialog": {
      "title": "Kurs stornieren",
      "description": "Sind Sie sicher, dass Sie diesen Kurs stornieren möchten? Diese Aktion kann nicht rückgängig gemacht werden."
    },
    "deleteDialog": {
      "title": "Kurs löschen",
      "description": "Sind Sie sicher, dass Sie diesen Kurs löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden."
    },
    "cancelSuccess": {
      "title": "Kurs storniert",
      "description": "Der Kurs wurde erfolgreich storniert."
    },
    "deleteSuccess": {
      "title": "Kurs gelöscht",
      "description": "Der Kurs wurde erfolgreich gelöscht."
    },
    "createSuccess": {
      "title": "Klasse erstellt",
      "description": "Die Klasse wurde erfolgreich erstellt."
    }
  },
  "classCard": {
    "editClass": "Kurs bearbeiten",
    "enrolled": "angemeldet",
    "status": "Status",
    "at": "um",
    "min": "Min.",
    "spots": "Plätze",
    "location": "Standort",
    "trainer": "Trainer",
    "enrolledClients": "Eingeschriebene Kunden",
    "noEnrolledClients": "Keine eingeschriebenen Kunden.",
    "confirmRemoval": "Entfernung bestätigen",
    "confirmRemovalDescription": "Sind Sie sicher, dass Sie {{name}} aus der Klasse entfernen möchten?",
    "clientHistory": "Buchungsverlauf für {{name}}",
    "lastBookings": "Nachfolgend finden Sie die Historie der letzten 10 Buchungen dieses Kunden.",
    "bookNow": "Jetzt buchen",
    "booked": "Gebucht",
    "classFullyBooked": "Ausgebucht"
  },
  "bookingSummary": {
    "title": "Buchungsübersicht",
    "description": "Bitte überprüfen Sie die Details Ihrer Kursbuchung",
    "min": "Min.",
    "cancellationPolicy": "Sie können Ihre Buchung bis zu 24 Stunden vor Kursbeginn kostenlos stornieren. Für Stornierungen, die weniger als 24 Stunden vor Kursbeginn vorgenommen werden, wird die volle Gebühr berechnet.",
    "agreeText": "Indem Sie fortfahren, stimmen Sie unseren",
    "terms": "Bedingungen",
    "and": "und",
    "privacyPolicy": "Datenschutzrichtlinie",
    "confirmBooking": "Buchung bestätigen",
    "sessions": "Anzahl der Sitzungen",
    "selectSessions": "Wählen Sie die Anzahl der Sitzungen",
    "sessionsDescription": "Bitte wählen Sie aus, wie viele Sitzungen Sie buchen möchten.",
    "bookingFailedTitle": "Buchung fehlgeschlagen",
    "bookingFailedDescription": "Die Klasse konnte nicht gebucht werden. Bitte versuchen Sie es später erneut.",
    "bookingFullDescription": "Diese Fitnessstunde ist ausgebucht. Bitte wählen Sie eine andere Stunde oder einen anderen Termin."
  },
  "login": {
    "title": "Anmelden",
    "description": "Geben Sie Ihre Anmeldedaten ein, um auf Ihr Konto zuzugreifen",
    "email": "E-Mail",
    "emailPlaceholder": "Geben Sie Ihre E-Mail ein",
    "password": "Passwort",
    "signIn": "Anmelden",
    "forgotPassword": "Passwort vergessen?"
  },
  "terms": {
    "title": "Allgemeine Geschäftsbedingungen",
    "scope": {
      "title": "1. Geltungsbereich",
      "description": "Diese Allgemeinen Geschäftsbedingungen („AGB“) gelten für die Nutzung unserer Fitnessstudio-Buchungsplattform („App“), über die Fitnessstudios ihre Kurse veröffentlichen und Nutzer diese buchen können. Durch die Registrierung und Nutzung der App erklären Sie sich mit diesen AGB einverstanden."
    },
    "services": {
      "title": "2. Bereitgestellte Dienstleistungen",
      "description": "Unsere App ermöglicht es Nutzern:",
      "features": {
        "browse": "Fitnesskurse von teilnehmenden Studios durchsuchen und buchen.",
        "manage": "Ihre Buchungen über ihr Benutzerkonto verwalten."
      },
      "disclaimer": "Wir fungieren ausschließlich als Plattformanbieter und sind nicht verantwortlich für die Qualität, Verfügbarkeit oder Durchführung der von Drittanbietern angebotenen Fitnesskurse."
    },
    "registration": {
      "title": "3. Benutzerregistrierung und Konten",
      "points": {
        "accurateInfo": "Nutzer müssen bei der Registrierung genaue und aktuelle Informationen angeben.",
        "confidentiality": "Jeder Nutzer ist für die Vertraulichkeit seiner Zugangsdaten verantwortlich.",
        "payment": "Diese App ist für Nutzer völlig kostenlos. Wir erheben keine Gebühren für Kursbuchungen, und Nutzer werden niemals aufgefordert, Zahlungen über die App zu leisten."
      }
    },
    "booking": {
      "title": "4. Buchung und Stornierung",
      "points": {
        "binding": "Buchungen sind nach Bestätigung verbindlich.",
        "cancellationPolicy": "Jedes Fitnessstudio legt seine eigene Stornierungsrichtlinie fest, an die sich die Nutzer halten müssen.",
        "refunds": "Wir sind nicht verantwortlich für Rückerstattungen oder Stornierungen; diese werden von den jeweiligen Fitnessstudios bearbeitet."
      }
    },
    "responsibilities": {
      "title": "5. Nutzerpflichten",
      "points": {
        "lawfulUse": "Nutzer verpflichten sich, die App rechtmäßig und nicht für betrügerische Aktivitäten zu nutzen.",
        "studioRules": "Nutzer müssen die Regeln und Richtlinien der Fitnessstudios, bei denen sie buchen, einhalten."
      }
    },
    "liability": {
      "title": "6. Haftung",
      "points": {
        "injuries": "Wir haften nicht für Verletzungen, Schäden oder Verluste, die während oder als Folge der Teilnahme an gebuchten Kursen auftreten.",
        "technicalMalfunctions": "Unsere Haftung für Schäden aufgrund technischer Störungen der App ist auf Fälle grober Fahrlässigkeit oder Vorsatz beschränkt."
      }
    },
    "dataProtection": {
      "title": "7. Datenschutz",
      "points": {
        "gdpr": "Nutzerdaten werden gemäß unserer Datenschutzrichtlinie und der DSGVO verarbeitet."
      }
    },
    "termination": {
      "title": "8. Kündigung und Kontosperrung",
      "points": {
        "suspension": "Wir behalten uns das Recht vor, Konten zu sperren oder zu kündigen, die gegen diese AGB verstoßen."
      }
    },
    "governingLaw": {
      "title": "9. Anwendbares Recht und Streitbeilegung",
      "points": {
        "germanLaw": "Diese AGB unterliegen deutschem Recht.",
        "disputeResolution": "Streitigkeiten werden vor deutschen Gerichten beigelegt."
      }
    }
  },
  "privacy": {
    "title": "Datenschutzrichtlinie",
    "introduction": {
      "title": "1. Einführung",
      "description": "Diese Datenschutzrichtlinie erklärt, wie wir Ihre persönlichen Daten gemäß der Datenschutz-Grundverordnung (DSGVO) und den deutschen Datenschutzgesetzen erfassen, verwenden und schützen."
    },
    "dataController": {
      "title": "2. Verantwortlicher für die Datenverarbeitung",
      "description": "PraxiPro ist der für die Verarbeitung Ihrer persönlichen Daten verantwortliche Datenverarbeiter."
    },
    "dataCollected": {
      "title": "3. Erfasste Daten",
      "description": "Wir erfassen die folgenden Daten:",
      "points": {
        "account": "Nur Name und E-Mail sind für die Kontoerstellung erforderlich.",
        "booking": "Buchungshistorie und Präferenzen."
      }
    },
    "purpose": {
      "title": "4. Zweck der Datenverarbeitung",
      "description": "Ihre Daten werden für folgende Zwecke verarbeitet:",
      "points": {
        "account": "Bereitstellung und Verwaltung Ihres Kontos.",
        "booking": "Erleichterung von Kursbuchungen.",
        "compliance": "Einhaltung unserer Nutzungsbedingungen und Verbesserung unserer Dienstleistungen."
      }
    },
    "dataSharing": {
      "title": "5. Weitergabe von Daten",
      "points": {
        "fitnessStudios": "Ihre Daten werden nur an Fitnessstudios weitergegeben, um Ihre Buchung zu ermöglichen."
      }
    },
    "dataSecurity": {
      "title": "6. Datensicherheit",
      "description": "Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten vor unbefugtem Zugriff und Missbrauch zu schützen."
    },
    "dataRetention": {
      "title": "7. Aufbewahrung von Daten",
      "points": {
        "retention": "Wir bewahren Ihre Daten so lange auf, wie es für die Erbringung unserer Dienstleistungen oder gesetzlich erforderlich ist.",
        "deletion": "Wenn Sie Ihr Konto löschen, werden alle mit Ihrem Konto verbundenen Daten dauerhaft entfernt. Es werden keine persönlichen Informationen oder verwandten Daten gespeichert, und Ihre Informationen werden vollständig aus unserem System gelöscht."
      }
    },
    "userRights": {
      "title": "8. Ihre Rechte",
      "description": "Als Nutzer haben Sie gemäß der DSGVO folgende Rechte:",
      "points": {
        "access": "Recht auf Zugriff, Berichtigung oder Löschung Ihrer persönlichen Daten.",
        "object": "Recht auf Widerspruch gegen die Datenverarbeitung.",
        "portability": "Recht auf Datenübertragbarkeit."
      }
    },
    "contact": {
      "title": "9. Kontaktinformationen",
      "description": "Bei datenschutzbezogenen Anfragen kontaktieren Sie uns bitte unter [hello@praxipro.de]."
    },
    "changes": {
      "title": "10. Änderungen dieser Richtlinie",
      "description": "Wir können diese Datenschutzrichtlinie regelmäßig aktualisieren. Nutzer werden über wesentliche Änderungen informiert."
    },
    "consent": {
      "description": "Durch die Nutzung unserer App stimmen Sie den in dieser Datenschutzrichtlinie dargelegten Bedingungen zu."
    }
  },
  "clientDashboard": {
    "title": "Meine Buchungen",
    "bookedClasses": "Meine gebuchten Kurse",
    "cancelSuccess": {
      "title": "Buchung storniert",
      "description": "Ihre Kursbuchung wurde erfolgreich storniert"
    },
    "cancelDialog": {
      "title": "Buchung stornieren",
      "description": "Sind Sie sicher, dass Sie diese Buchung stornieren möchten? Diese Aktion kann nicht rückgängig gemacht werden."
    },
    "cannotCancel": "Stornierung innerhalb von 24h nicht möglich"
  },
  "dashboard": {
    "createNewClass": "Neue Klasse erstellen",
    "upcomingClasses": "Kommende Kurse",
    "historicalClasses": "Historische Kurse",
    "createClass": {
      "title": "Neue Klasse erstellen",
      "description": "Füllen Sie die Details für Ihre neue Klasse aus.",
      "create": "Klasse erstellen"
    },
    "editClass": {
      "title": "Klasse bearbeiten",
      "description": "Aktualisieren Sie die Details für Ihre Klasse.",
      "update": "Klasse aktualisieren"
    },
    "stats": {
      "totalClasses": "Gesamtzahl der Klassen",
      "totalStudents": "Gesamtzahl der Schüler"
    }
  },
  "forgotPassword": {
    "title": "Passwort zurücksetzen",
    "description": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link, um Ihr Passwort zurückzusetzen.",
    "emailLabel": "E-Mail",
    "emailPlaceholder": "Geben Sie Ihre E-Mail-Adresse ein",
    "sendResetLinkButton": "Reset-Link senden",
    "sendingButton": "Wird gesendet...",
    "backToLoginButton": "Zurück zum Login",
    "rememberPassword": "Erinnern Sie sich an Ihr Passwort?",
    "toastSuccessTitle": "Passwort-Reset-Link gesendet",
    "toastSuccessDescription": "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie einen Link zum Zurücksetzen des Passworts.",
    "toastErrorTitle": "Fehler beim Zurücksetzen des Passworts",
    "toastErrorDescription": "Es gab ein Problem beim Zurücksetzen Ihres Passworts. Bitte versuchen Sie es später erneut."
  },
  "resetPassword": {
    "title": "Passwort zurücksetzen",
    "description": "Geben Sie Ihr neues Passwort ein, um den Reset abzuschließen.",
    "confirmRegistrationTitle": "Wählen Sie ein Passwort",
    "confirmRegistrationDescription": "Geben Sie Ihr neues Passwort ein, um den Registrierungsprozess abzuschließen.",
    "newPasswordLabel": "Neues Passwort",
    "confirmPasswordLabel": "Passwort bestätigen",
    "sendResetLinkButton": "Zurücksetzen senden",
    "sendingButton": "Wird gesendet...",
    "toastPasswordMismatchTitle": "Passwörter stimmen nicht überein",
    "toastPasswordMismatchDescription": "Stellen Sie sicher, dass beide Passwörter identisch sind.",
    "toastSuccessTitle": "Passwort zurückgesetzt",
    "toastSuccessDescription": "Ihr Passwort wurde erfolgreich zurückgesetzt.",
    "toastErrorTitle": "Fehler beim Zurücksetzen des Passworts",
    "toastErrorDescription": "Es gab ein Problem beim Zurücksetzen Ihres Passworts. Bitte versuchen Sie es später erneut."
  },
  "authDialog": {
    "loginTitle": "Melden Sie sich an, um einen Kurs zu buchen",
    "signUpTitle": "Registrieren Sie sich, um einen Kurs zu buchen",
    "loginDescription": "Bitte melden Sie sich an, um Ihre Buchung zu bestätigen",
    "signUpDescription": "Erstellen Sie ein Konto, um Kurse zu buchen",
    "firstName": "Vorname",
    "firstNamePlaceholder": "John",
    "lastName": "Nachname",
    "lastNamePlaceholder": "Doe",
    "email": "E-Mail",
    "emailPlaceholder": "john@example.com",
    "password": "Passwort",
    "forgotPassword": "Passwort vergessen?",
    "loginButton": "Anmelden & Buchen",
    "signUpButton": "Registrieren & Buchen",
    "switchToSignUp": "Kein Konto? Jetzt registrieren",
    "switchToLogin": "Haben Sie bereits ein Konto? Anmelden",
    "loginFailed": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "emailAlreadyExists": "Diese E-Mail ist bereits registriert. Bitte melde dich an. Falls du dein Passwort vergessen hast, nutze die Funktion ‚Passwort vergessen‘.",
    "registrationFailed": "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "registrationSuccessful": "Registrierung erfolgreich! Bitte überprüfen Sie Ihre E-Mails, um Ihre E-Mail-Adresse zu bestätigen."
  },
  "common": {
    "class": "Kurs",
    "date": "Datum",
    "time": "Zeit",
    "duration": "Dauer",
    "trainer": "Trainer",
    "price": "Preis",
    "location": "Ort",
    "status": "Status",
    "actions": "Aktionen",
    "minutes": "Minuten",
    "completed": "Abgeschlossen",
    "cancel": "Stornieren",
    "delete": "Löschen",
    "close": "Schließen",
    "booked": "Gebucht",
    "canceled": "Abgesagt",
    "keepBooking": "Buchung behalten",
    "confirmCancel": "Ja, stornieren",
    "backToClasses": "Zurück zu den Kursen",
    "logout": "Abmelden",
    "pickMonth": "Wähle einen Monat",
    "pickDate": "Wähle ein Datum",
    "clear": "Löschen",
    "remove": "Entfernen",
    "submit": "Absenden",
    "pleaseWait": "Bitte warten..."
  },
  "contactUs": {
    "title": "Brauchen Sie Hilfe? Kontaktieren Sie unsere Buchungssoftware-Experten",
    "getInTouch": "Kontaktieren Sie uns, um Ihr Studio zu registrieren und Ihre kostenlose Testversion zu starten",
    "subHeading": "Wir würden uns freuen, von Ihnen zu hören! Egal ob Sie Fragen zu Funktionen, Preisen oder etwas anderem haben – unser Team beantwortet Ihnen gerne alles.",
    "fillOutContactForm": "Füllen Sie das Formular aus und wir melden uns so schnell wie möglich bei Ihnen.",
    "name": "Name",
    "enterName": "Geben Sie Ihren Namen ein",
    "email": "E-Mail",
    "enterEmail": "Geben Sie Ihre E-Mail-Adresse ein",
    "studioName": "Studioname",
    "enterStudioName": "Studioname eingeben",
    "message": "Nachricht",
    "enterMessage": "Geben Sie Ihre Nachricht ein",
    "sendMessage": "Nachricht senden",
    "sendingMessage": "Nachricht wird gesendet",
    "submit": "Absenden",
    "nameMin": "Der Name muss mindestens 2 Zeichen lang sein.",
    "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "messageMin": "Die Nachricht muss mindestens 10 Zeichen enthalten.",
    "requestSent": "Anfrage gesendet",
    "weWillGetBack": "Wir melden uns in Kürze bei Ihnen!",
    "toastErrorTitle": "Ein Fehler ist aufgetreten",
    "toastErrorDescription": "Beim Verarbeiten Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
    "alertStudioProfessional": "Dieses Formular richtet sich an Studio-Profis, die ihr Studio registrieren möchten.",
    "needSupport": {
      "title": "Brauchen Sie Hilfe?",
      "description": "Erhalten Sie sofort Antworten."
    },
    "feedback": {
      "title": "Feedback?",
      "description": "Teilen Sie es uns hier mit."
    },
    "reportIssue": {
      "title": "Problem melden",
      "description": "Erhalten Sie bevorzugten Support."
    },
    "community": {
      "title": "Community",
      "description": "Vernetzen Sie sich mit anderen Nutzern."
    }
  },
  "landing": {
    "title": "Studiomanagement-Software für Fitnessstudios",
    "heroTitle": "Moderne Studio-App für Yoga, Pilates, Physiotherapie & CANTIENICA",
    "heroDescription": "Die All-in-One-Plattform für Fitnessstudio-Inhaber, um Kurse, Kunden zu verwalten und ihr Geschäft effizient zu steigern.",
    "ctaText": "Kostenlose Testversion starten",
    "featuresSectionTitle": "Alles, was Sie benötigen, um Ihr Studio zu führen",
    "featuresSectionDescription": "Leistungsstarke Werkzeuge, die speziell für Fitnessstudio-Inhaber entwickelt wurden",
    "classManagementTitle": "Kursmanagement",
    "classManagementDescription": "Verwalten Sie problemlos Ihren Kursplan, buchen Sie und verfolgen Sie die Anwesenheit in Echtzeit",
    "clientManagementTitle": "Kundenmanagement",
    "clientManagementDescription": "Behalten Sie Ihre Kunden, deren Buchungshistorie und Mitgliedschaften an einem Ort im Blick",
    "businessAnalyticsTitle": "Geschäftsanalytik",
    "businessAnalyticsDescription": "Erhalten Sie Einblicke in die Leistung Ihres Studios mit detaillierten Berichten und Analysen",
    "benefitsSectionTitle": "Steigern Sie Ihr Geschäft mit intelligenten Werkzeugen",
    "benefitsSectionDescription": "Intelligente Werkzeuge, um Ihr Geschäft zu fördern.",
    "benefit1": "Reduzieren Sie No-Shows mit automatisierten Erinnerungen",
    "benefit2": "Steigern Sie den Umsatz mit flexiblen Preisoptionen",
    "benefit3": "Sparen Sie Zeit mit automatischer Planung",
    "benefit4": "Verbessern Sie die Kundenbindung mit Engagement-Tools",
    "benefit5": "Treffen Sie datenbasierte Entscheidungen mit detaillierten Analysen",
    "benefit6": "Optimieren Sie den Betrieb mit integrierten Tools",
    "ctaSectionTitle": "Bereit, Ihr Studio-Management zu transformieren?",
    "ctaSectionDescription": "Schließen Sie sich erfolgreichen Studioinhabern an, die ihre Betriebsabläufe mit unserer Plattform optimiert haben.",
    "featuredStudiosTitle": "Vorgestellte Studios mit FitCalendar",
    "featuredStudiosIntro": "Schließen Sie sich diesen erfolgreichen Fitnessunternehmen an, die ihre Abläufe mit unserer Plattform transformiert haben",
    "physiotherapyPractice": "Physiotherapiepraxis",
    "onlineBooking": "Online-Buchung",
    "howFitCalendarWorksTitle": "So funktioniert FitCalendar",
    "howFitCalendarWorksIntro": "Starten Sie in nur vier einfachen Schritten",
    "howFitCalendarWorksStep1Title": "Registrieren",
    "howFitCalendarWorksStep1Intro": "Erstellen Sie in wenigen Minuten Ihr Konto und Ihr Profil",
    "howFitCalendarWorksStep2Title": "Erstellen",
    "howFitCalendarWorksStep2Intro": "Fügen Sie Ihre Kurse hinzu und machen Sie Ihr Studio buchungsbereit",
    "howFitCalendarWorksStep3Title": "Integrieren",
    "howFitCalendarWorksStep3Intro": "Verbinden Sie Ihre bestehenden Tools und fügen Sie den Buchungslink zu Ihrer Website hinzu",
    "howFitCalendarWorksStep4Title": "Wachsen",
    "howFitCalendarWorksStep4Intro": "Konzentrieren Sie sich auf Ihre Kunden – wir übernehmen die Verwaltung",
    "viewPricing": "Preise anzeigen",
    "rating": "Bewertung",
    "happyUsers": "Zufriedene Nutzer",
    "freeTrial": "Kostenlose Testversion",
    "realTimeDashboard": "Echtzeit-Studio-Dashboard",
    "trackYourStudioPerformance": "Verfolgen Sie die Leistung Ihres Studios"
  },
  "pricing": {
    "title": "Preise",
    "header": "Preiswerte Tarife für Fitness-Buchungssoftware",
    "subHeader": "Ein erschwingliches Abo für alles, was Ihre Praxis braucht – Kursplanung, Buchungen und Studioverwaltung leicht gemacht.",
    "freeTrial": "Kostenlose Testversion",
    "freeTrialDesc": "Für Studios, die die Plattform testen",
    "freeTrialFeatures": [
      "14 Tage voller Zugriff",
      "Grundlegende Kalenderverwaltung",
      "Bis zu 5 Kurse pro Woche",
      "Einfache Kundenprofile"
    ],
    "startFreeTrial": "Testversion starten",
    "standard": "Standard",
    "standardDesc": "Pro Studio, monatlich abgerechnet",
    "standardFeatures": [
      "Unbegrenzte Kurse und Termine",
      "Erweiterte Kalenderverwaltung",
      "Online-Buchung für Kunden",
      "Komplettes Kundenverwaltungssystem",
      "Zahlungsintegration",
      "Basisberichte und Analysen",
      "E-Mail-Support"
    ],
    "subscribeNow": "Jetzt abonnieren",
    "annual": "Jahresabo",
    "annualDesc": "Spare 20 % mit jährlicher Abrechnung",
    "annualFeatures": [
      "Alle Standardfunktionen",
      "2 Monate gratis (entspricht 16 €/Monat)",
      "Priorisierter Kundensupport",
      "Erweiterte Berichte und Analysen"
    ],
    "subscribeAnnually": "Jährlich abonnieren",
    "popularPlan": "Am beliebtesten",
    "perMonth": "/Monat",
    "perYear": "/Jahr",
    "faqsTitle": "Häufig gestellte Fragen",
    "faqsQ1": "Kann ich meinen Plan upgraden oder downgraden?",
    "faqsA1": "Ja, Sie können jederzeit auf ein Jahresabo upgraden. Ein Downgrade auf monatlich ist nach Ablauf des Jahresabos möglich.",
    "faqsQ2": "Gibt es Rabatte für mehrere Studios?",
    "faqsA2": "Ja! Für Studios mit mehreren Standorten bieten wir Mengenrabatte. Kontaktieren Sie unser Vertriebsteam für ein individuelles Angebot.",
    "faqsQ3": "Welche Zahlungsmethoden werden akzeptiert?",
    "faqsA3": "Wir akzeptieren alle gängigen Kreditkarten und PayPal. Für Jahresabos sind auch Banküberweisungen möglich.",
    "faqsQ4": "Gibt es eine Einrichtungsgebühr?",
    "faqsA4": "Nein, es gibt keine versteckten Gebühren. Ihr Abo deckt alles ab – inklusive Einrichtung, Hosting und regelmäßiger Updates."
  },
  "affiliate": {
    "title": "Affiliate-Programm",
    "heading": "💼 Trete unserem Affiliate-Programm bei",
    "description": "Verdiene Geld, indem du Yoga-, Pilates-, Fitness-Trainer:innen, Physiotherapeut:innen, CANTIENICA-Profis und Bewegungstrainer:innen an FitCalendar empfiehlst. Es ist einfach, lohnend und wächst mit dir.",
    "rewardOne": {
      "amount": "💶 96 €",
      "text": "für jede:n neue:n Nutzer:in, der/die ein Jahresabo abschließt."
    },
    "rewardTwo": {
      "amount": "📅 8 €/Monat",
      "text": "pro Nutzer:in für ein Jahr bei monatlicher Abrechnung."
    },
    "rewardThree": {
      "title": "🏆 Lebenslanger Bonus:",
      "description": "Empfiehl mehr als 50 zahlende Nutzer:innen und erhalte",
      "amount": "3 €/Monat",
      "forever": "für immer"
    },
    "ctaHeading": "🎉 Starte noch heute",
    "ctaDescription": "Fülle das untenstehende Formular aus und erhalte deinen persönlichen Empfehlungscode per E-Mail. Teile ihn und verdiene Geld!",
    "form": {
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail-Adresse",
      "submit": "Meinen Empfehlungscode erhalten",
      "loading": "Registrierung läuft..."
    },
    "firstNameMin": "Vorname ist erforderlich",
    "lastNameMin": "Nachname ist erforderlich",
    "emailInvalid": "Ungültige E-Mail-Adresse"
  },
  "register": {
    "title": "Studio-Registrierung",
    "description": "Registriere dein Studio und starte deine kostenlose Testphase",
    "name": "Name",
    "enterName": "Gib deinen Namen ein",
    "email": "E-Mail",
    "enterEmail": "Gib deine E-Mail-Adresse ein",
    "studioName": "Studio-Name",
    "enterStudioName": "Studio-Name eingeben",
    "message": "Nachricht",
    "enterMessage": "Gib deine Nachricht ein",
    "sendMessage": "Nachricht senden",
    "sendingMessage": "Nachricht wird gesendet",
    "submit": "Absenden",
    "submitting": "Wird gesendet...",
    "nameMin": "Der Name muss mindestens 2 Zeichen lang sein.",
    "emailInvalid": "Bitte gib eine gültige E-Mail-Adresse ein.",
    "messageMin": "Die Nachricht muss mindestens 10 Zeichen lang sein.",
    "requestSent": "Anfrage gesendet",
    "weWillGetBack": "Wir melden uns in Kürze bei dir!",
    "toastErrorTitle": "Ein Fehler ist aufgetreten",
    "toastErrorDescription": "Beim Verarbeiten deiner Anfrage ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
    "alertStudioProfessional": "Dieses Formular ist für Studio-Profis gedacht, die ihr Studio registrieren möchten."
  },
  "guides": {
    "title": "Ressourcenbibliothek"
  },
  "blog": {
    "title": "Tipps zu Yoga, Pilates, CANTIENICA & Fitness"
  },
  "clients": {
    "title": "Kundenliste",
    "description": "Verwalten Sie Ihre Fitnesskunden und sehen Sie deren Buchungshistorie ein.",
    "listTitle": "Kundendatenbank",
    "searchPlaceholder": "Nach Name oder E-Mail suchen...",
    "searchButton": "Suchen",
    "searching": "Suche...",
    "table.name": "Name",
    "table.email": "E-Mail",
    "table.totalBookings": "Gesamtbuchungen",
    "table.actions": "Aktionen",
    "table.class": "Kurs",
    "table.date": "Datum",
    "table.time": "Uhrzeit",
    "table.duration": "Dauer",
    "table.price": "Preis",
    "table.status": "Status",
    "viewClasses": "Buchungen anzeigen",
    "loading": "Wird geladen...",
    "noClientsFound": "Keine Kunden gefunden.",
    "searchError.apiTitle": "Fehler",
    "searchError.apiDescription": "Daten vom Server konnten nicht geladen werden.",
    "searchError.title": "Suchwarnung",
    "minLengthWarning": "Bitte geben Sie mindestens 3 Zeichen ein, um zu suchen.",
    "bookingsTitle": "Buchungen für {{name}}",
    "noBookings": "Keine Buchungsdaten verfügbar.",
    "bookingsDescription": "Unten sehen Sie die Historie aller Buchungen dieses Kunden.",
    "status.booked": "Gebucht",
    "status.canceled": "Storniert"
  }
}